module.exports = __webpack_public_path__ + "static/media/kv-zh-Hant.c2e25505.jpg";